
import './App.css';
import Tictactoe from './TicTacToe/Tictactoe';

function App() {
  return (
    <div className="App">
    <h1 className='app-header'>Tic-Tac-Toe</h1>
     <Tictactoe />
    </div>
  );
}

export default App;
